/*
 * Карточка звонка в переписке: как назвать звонок с точки зрения читателя.
 * Одна и та же запись у звонившего — «Исходящий», у собеседника — «Входящий»;
 * пропущенный выделяется только у того, кто его пропустил.
 */

export type CallInfo = {
  /** Идентификатор звонка: по нему открываются его переписка и итоги. */
  id: string;
  kind: 'audio' | 'video';
  startedById: string;
  answered: boolean;
  seconds: number;
  reason: string;
  /** Сколько человек побывало в звонке. */
  participants: number;
  /** Звонок команды из канала. */
  channel: boolean;
  /** Сколько сообщений в переписке звонка; 0 — переписки не было. */
  messages: number;
};

export const clock = (sec: number): string =>
  `${Math.floor(sec / 60)}:${String(sec % 60).padStart(2, '0')}`;

const peopleWord = (n: number): string => {
  const teens = n % 100;
  const last = n % 10;
  if (teens > 10 && teens < 15) return 'участников';
  if (last === 1) return 'участник';
  if (last >= 2 && last <= 4) return 'участника';
  return 'участников';
};

export function callCardText(call: CallInfo, myId: string): { title: string; missed: boolean } {
  const mine = call.startedById === myId;
  const noun = call.kind === 'video' ? 'видеозвонок' : 'звонок';
  // звонок команды не бывает «исходящим» или «входящим»: в нём несколько
  // человек, и читателю важен состав, а не направление
  if (call.channel || call.participants > 2) {
    if (call.answered) {
      return {
        title: `Звонок команды · ${clock(call.seconds)} · ${call.participants} ${peopleWord(call.participants)}`,
        missed: false,
      };
    }
    return { title: 'Пропущенный звонок команды', missed: !mine };
  }
  if (call.answered) {
    return { title: `${mine ? 'Исходящий' : 'Входящий'} ${noun} · ${clock(call.seconds)}`, missed: false };
  }
  if (call.reason === 'declined') {
    return mine
      ? { title: 'Отклонён', missed: false }
      : { title: `Отклонённый ${noun}`, missed: false };
  }
  if (mine) {
    return { title: call.reason === 'failed' ? 'Не дозвонились' : 'Не ответили', missed: false };
  }
  return { title: `Пропущенный ${noun}`, missed: true };
}
